var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentStyle.comp,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b({ attrs: { icon: "" } }, "v-btn", attrs, false),
                      on
                    ),
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            content: _vm.unreadNotifications,
                            color: _vm.unreadNotifications ? "soli-red" : null,
                            overlap: "",
                            bordered: !!_vm.unreadNotifications,
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "text-shadow-blue",
                              attrs: {
                                color:
                                  _vm.$page.component == "Explore"
                                    ? "white"
                                    : "accent",
                              },
                            },
                            [_vm._v("notifications")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        "component",
        { ..._vm.componentStyle.props },
        false
      ),
      _vm.componentStyle.on
    ),
    [
      _vm._v(" "),
      _c(
        "v-sheet",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "div",
                    [
                      _c("v-card-title", { staticClass: "soli-grey" }, [
                        _vm._v("Notifications"),
                      ]),
                      _vm._v(" "),
                      !_vm.untouchedNotifications
                        ? _c("v-card-subtitle", { staticClass: "soli-grey" }, [
                            _vm._v("You're all caught up!"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-4",
                      attrs: {
                        icon: "",
                        color: "dark",
                        small: "",
                        href: `/profile/${_vm.$page.props.auth.user.id}/preferences`,
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("settings"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  directives: [
                    {
                      name: "scroll",
                      rawName: "v-scroll.self",
                      value: _vm.onScroll,
                      expression: "onScroll",
                      modifiers: { self: true },
                    },
                  ],
                  staticClass: "overflow-y-auto",
                  attrs: { "max-height": "600" },
                },
                [
                  _vm._l(_vm.notifications.data, function (item, idx) {
                    return _c(
                      "v-list-item",
                      {
                        key: idx,
                        class: {
                          unread: !item.interacted_at,
                          "cursor-pointer": !item.interacted_at,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(item)
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-avatar",
                          [_c("v-img", { attrs: { src: item.data.image } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-content",
                          [
                            _c(
                              "v-list-item-title",
                              {
                                staticClass: "ws-wrap",
                                class: {
                                  "soli-grey": item.interacted_at,
                                },
                              },
                              [_vm._v(_vm._s(item.data.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-subtitle",
                              { staticClass: "ws-wrap" },
                              [_vm._v(_vm._s(item.data.subtitle))]
                            ),
                            _vm._v(" "),
                            item.data.download
                              ? _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "caption" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: "",
                                          left: "",
                                          color: "dark",
                                        },
                                      },
                                      [_vm._v("attachment")]
                                    ),
                                    _vm._v(_vm._s(item.data.file_name)),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("small", { staticClass: "accent--text" }, [
                              _vm._v(
                                _vm._s(_vm.moment(item.created_at).fromNow())
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("v-skeleton-loader", {
                        staticClass: "mx-auto my-3",
                        attrs: { type: "list-item-avatar-three-line@3" },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }